import { BaseModel } from './base.model';

export class SignUpInterviewModel extends BaseModel {
  target: string;
  activities: string;
  position: string;
  countEmployees: string;
}
